import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { getBranch } from '../../store/user/selectors'
import { URLS } from '../../resources/constants'
import { gustoApi } from '../../resources/hooks/api/gustoApiHook'

interface Props { }

const GustoCallback: React.FC<Props> = () => {

    const { gustoCallback } = gustoApi();
    const branchData = useSelector(getBranch)

    const [searchParams, setSearchParams] = useSearchParams();

    const _handleRetriveRecord = (code: string/*, state: string, realmId: string*/) => {
        const params = {
            code: code,
            redirect_uri: window.location.origin + URLS.GUSTO_CALLBACK,
            branch_id: +branchData['id'],
        }
        gustoCallback(params, (message: string, resp: any) => {
            window.close();
        }, (message: string, resp: any) => {
            console.log(resp)
        })
    }

    useEffect(() => {
        const code: string = searchParams.get('code') ? searchParams.get('code')! : '';

        _handleRetriveRecord(code/*, state, realmId*/);
    }, [ searchParams ])

    return (
        <div className="main-container flex-grow-1">
        </div>
    )
}

export default GustoCallback
